import React, { useState } from 'react';
import Main from '../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import { SbAddBtn, SbFilterBtn } from '../Buttons/Buttons';
import Select from 'react-select';
import Download from '../MainSection/Download/Download';
import SbDropdownButton from '../Buttons/SbDropdownButton';
import CartMasterTable from './CartMasterTable';
import AddCartMaster from './AddCartMaster';
import CartMasterBulkUploadModal from './CartMasterBulkUploadModal';
import ViewCartMasterModal from './ViewCartMasterModal';

const statusOptions = [
    { value: "All", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "In-Process", label: "In-Process" },
    { value: "Resolved", label: "Resolved" },
    { value: "Re-Open", label: "Re-Open" },
    { value: "Cancel", label: "Cancel" },
]
const CartMaster = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenViewModal = () => {
        setShowViewDetails(!showViewDetails);
    }

    const handleCloseViewModal = () => {
        setShowViewDetails(false)
    }

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Location Master"
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Cart Master</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                {/* <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        // options={statusOptions}
                                        style={{ width: "100%" }}
                                    />
                                </Col> */}
                                <SbDropdownButton
                                    // pageName="Zone Master"
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <CartMasterTable
                                handleOpenModal={handleOpenModal}
                                handleOpenViewModal={handleOpenViewModal}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddCartMaster
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                />
            }
            {
                showBulkUploadModal && <CartMasterBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                // deptData={deptData}
                />
            }
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {showViewDetails && (
                <ViewCartMasterModal
                    showViewDetails={showViewDetails}
                    handleCloseViewModal={handleCloseViewModal}
                />
            )}
        </div >
    );
};

export default CartMaster;